import { atom } from "recoil";

export const addStateBusinessOperation = atom({
  key: "addStateBusinessOperation",
  default: false,
});
export const editStateBusinessOperation = atom({
  key: "editStateBusinessOperation",
  default: false,
});
export const rowEditIdStateBusinessOperation = atom({
  key: "rowEditIdStateBusinessOperation",
  default: null,
});
export const disableButtonStateBusinessOperation = atom({
  key: "disableButtonStateBusinessOperation",
  default: false,
});

export const selectedRowsStateBusinessOperation = atom({
  key: "selectedRowsStateBusinessOperation",
  default: [],
});

export const setFilterTextBusinessOperation = atom({
  key: "setFilterTextBusinessOperation",
  default: "",
});
